import React, { useContext, useEffect, useState } from "react";
import jwt_decode from "jwt-decode";

import { auth } from "../api";
import {
  getAccessToken,
  setConfiguration,
  getConfiguration,
  setAccessToken,
  clearAccessToken,
  setUserRole,
  getUserRole,
  clearUserRole,
} from "../utils/browserStorage.js";
import NewDashboardContext from "./NewDashboardContext";
import LoadingIndicator from "../components/LoadingIndicator/index.jsx";

const AuthContext = React.createContext();
const configuration = getConfiguration();
const userRole = getUserRole();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [username, setUsername] = useState();
  const [email, setEmail] = useState();
  const [firstName, setFirstName] = useState();
  const [config, setConfig] = useState();
  const [authUser, setAuthUser] = useState();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isCheckingCred, setCheckingCred] = useState(true);
  const [allowedPermissions, setAllowedPermissions] = useState([]);
  const [overviewPage, setOverviewPage] = useState("admin");

  function getCompanyAccess() {
    const master = config?.RoleCompanyMaster;
    if (master?.length) {
      return master[0].feature_access;
    } else {
      return [];
    }
  }

  async function checkCreds() {
    const token = getAccessToken();
    //should check token to BE

    if (token) {
      try {
        const result = await auth.self();
        if (result.ok) {
          const body = await result.json();
          const user = body.data;
          setConfig(user.companies[0].company); //neeed to change later
          setConfiguration(JSON.stringify(user.companies[0].company)); //neeed to change later
          setUsername(user.username);
          setFirstName(user.firstname);
          setAuthUser(user);

          setEmail(user.email);

          //set cmms role
          if (user.companies[0].cmms_role) {
            const ps = [];
            user.companies[0].cmms_role.permissions.map((p) => {
              ps.push(`${p.permission.action} ${p.permission.target}`);
            });
            setAllowedPermissions(ps);
            console.log(ps);
          }

          //set cgm role
          if (user.companies[0].role) {
            setUserRole(JSON.stringify(user.companies[0].role));
            setOverviewPage(user.companies[0].role.overview_page);
          }

          setIsAuthenticated(true);
        }
      } catch (e) {
        setIsAuthenticated(false);
      } finally {
        setCheckingCred(false);
      }
    } else {
      setIsAuthenticated(false);
      setCheckingCred(false);
    }
  }

  async function checkCredsOld() {
    const token = getAccessToken();
    //should check token to BE

    if (token) {
      //simulate checking to BE
      await new Promise((res, rej) =>
        setTimeout(() => {
          res(true);
        }, 2000)
      );
      const content = jwt_decode(token);
      const currentTimeInMilliSeconds = new Date().getTime();
      if (content.exp * 1000 > currentTimeInMilliSeconds) {
        setUsername(content.username);
        setEmail(content.email);
        setConfig(configuration);
        setIsAuthenticated(true);
        setCheckingCred(false);

        return true;
      }
    }

    setCheckingCred(false);
    return false;
  }

  function isInLoginPage() {
    console.log("check login");
    console.log({ pathname: window.location.pathname });
    return window.location.pathname === "/login";
  }

  useEffect(() => {
    checkCreds();
  }, []);

  async function login(email, password, chosen_company, token) {
    let response;

    try {
      response = await auth.login(email, password, chosen_company, token);
    } catch (err) {
      return [false, "Server Error"];
    }

    if (response?.status === 401) {
      return [false, "Invalid email or password"];
    }

    const body = await response.json();
    if (response?.ok && body.success) {
      const data = body.data;

      if (!Object.keys(data).length || !data?.token) {
        return [false, "Bad API response"];
      }

      setAccessToken(data.token);
      setConfig(data.user.companies[0].company); //neeed to change later
      setConfiguration(JSON.stringify(data.user.companies[0].company)); //neeed to change later
      setUsername(data.user.username);

      setEmail(data.user.email);

      // await checkCreds();
      setTimeout(() => {}, 100);
      return [true, null, data.user];
    }

    return [false, body?.message || response?.statusText, null];
  }
  async function loginByPass(token) {
    let response;

    try {
      response = await auth.loginByPass(token);
    } catch (err) {
      return [false, "Server Error"];
    }

    if (response?.status === 401) {
      return [false, "Invalid email or password"];
    }

    const body = await response.json();
    if (response?.ok && body.success) {
      const data = body.data;

      if (!Object.keys(data).length || !data?.token) {
        return [false, "Bad API response"];
      }

      setAccessToken(data.token);
      setConfig(data.user.companies[0].company); //neeed to change later
      setConfiguration(JSON.stringify(data.user.companies[0].company)); //neeed to change later
      setUsername(data.user.username);

      setEmail(data.user.email);

      // await checkCreds();
      setTimeout(() => {}, 100);
      return [true, null, data.user];
    }

    return [false, body?.message || response?.statusText, null];
  }

  function getLocationName(index) {
    if (config?.location_wording) {
      const words = config?.location_wording.split(",");
      return words[index];
    }
    return "undefined";
  }

  function isHiddenFeature(feature) {
    if (
      window.location.href.includes("testing") ||
      window.location.href.includes("localhost")
    )
      return false;
    if (configuration?.hidden_features) {
      return configuration.hidden_features.includes(feature);
    } else {
      return true;
    }
  }

  function isLocationAllowed(locationId) {
    if (userRole) {
      const role = JSON.parse(userRole);
      const allowedLocations = role?.accesses;
      return allowedLocations?.includes(locationId);
    }

    return false;
  }

  function logout() {
    clearAccessToken();
    clearUserRole();
    setUsername(null);
    setEmail(null);
    setUserRole(null);
    setConfig(null);
  }

  function hasFeatureAccess(featureName, action) {
    const userRoleJSON = getUserRole();
    if (userRoleJSON) {
      const userRole = JSON.parse(userRoleJSON);

      if (userRole && userRole.roleFeatureAccess) {
        const allowd = userRole.roleFeatureAccess.find(
          (item) => item.page_name == featureName && item[action] == true
        );
        if (allowd) {
          return true;
        }
      }
    }
    return false;
  }

  function viewMachineAlertStatus() {
    return hasFeatureAccess("Machine Alert Status", "can_view");
  }

  function viewMachineHealth() {
    return hasFeatureAccess("Machine Health", "can_view");
  }

  function viewMachineOnlineStatus() {
    return hasFeatureAccess("Machine Online Status", "can_view");
  }

  function viewMachineUptime() {
    return hasFeatureAccess("Machine Uptime	", "can_view");
  }

  function viewManualAlertEntry() {
    return hasFeatureAccess("Manual Alert Entry", "can_view");
  }
  function viewGINA() {
    return hasFeatureAccess("GINA Feature", "can_view");
  }
  function createManualAlertEntry() {
    return hasFeatureAccess("Manual Alert Entry", "can_create");
  }
  function updateManualAlertEntry() {
    return hasFeatureAccess("Manual Alert Entry", "can_update");
  }
  function deleteManualAlertEntry() {
    return hasFeatureAccess("Manual Alert Entry", "can_delete");
  }

  function viewMachineProfile() {
    return hasFeatureAccess("MACHINE PROFILES", "can_view");
  }
  function createMachineProfile() {
    return hasFeatureAccess("MACHINE PROFILES", "can_create");
  }
  function updateMachineProfile() {
    return hasFeatureAccess("MACHINE PROFILES", "can_update");
  }
  function deleteMachineProfile() {
    return hasFeatureAccess("MACHINE PROFILES", "can_delete");
  }
  function viewAlertCount() {
    return hasFeatureAccess("Alert Count", "can_view");
  }

  function viewAlertDetails() {
    return hasFeatureAccess("Alert Details", "can_view");
  }
  function updateAlertDetails() {
    return hasFeatureAccess("Alert Details", "can_update");
  }

  const value = {
    config,
    username,
    firstName,
    email,
    isAuthenticated,
    authUser,
    allowedPermissions,
    login,
    getCompanyAccess,
    checkCreds,
    logout,
    loginByPass,
    isInLoginPage,
    viewMachineAlertStatus,
    viewMachineHealth,
    viewMachineOnlineStatus,
    viewMachineUptime,

    viewManualAlertEntry,
    createManualAlertEntry,
    updateManualAlertEntry,
    deleteManualAlertEntry,
    viewGINA,
    viewMachineProfile,
    createMachineProfile,
    updateMachineProfile,
    deleteMachineProfile,

    viewAlertDetails,
    updateAlertDetails,

    viewAlertCount,
    getLocationName,
    isHiddenFeature,
    isLocationAllowed,
    overviewPage,
    setConfig,
  };

  return (
    <AuthContext.Provider value={value}>
      {isCheckingCred && <div className="loader"></div>}

      {!isCheckingCred && children}
    </AuthContext.Provider>
  );
}
